module.exports = __webpack_public_path__ + "img/magnifier.be2beb56.svg";